import React, {Component, Fragment} from "react";
import {Card, CardBody} from "reactstrap";
import TransactionStatus from "../../domain/Transaction/TransactionStatus";
import "../../views/Authenticated/Transactions/transaction.css";
import "flag-icon-css/css/flag-icon.css";

export default class TransactionCardBrowser extends Component {


    constructor(props, context) {
        super(props, context);
        this.state = {
            modalOpen: false,
            quotationRequest: undefined
        };

    }

    render() {
        return <Fragment>
            {this.renderTransactionCards(this.props.transactionData)}
            {this.state.modalOpen && this.renderModal()}
        </Fragment>
    }

    renderTransactionCards(transaction) {
        return <Fragment>
            <Card style={{border: "none"}}>
                <CardBody>
                    <div style={{padding: "4px 8px", display: "flex", margin: "auto", width: "100%", fontSize: "11pt"}}>
                        {this.renderHeader(transaction)}
                    </div>
                </CardBody>
            </Card>
            <hr style={{width: "100%", margin: "0"}}/>
        </Fragment>
    }

    renderHeader(transaction) {

        return <Fragment>
            <div style={{display: "flex", margin: "auto", width: "100%", flex: "6"}}>
                <div style={{
                    marginRight: "15px",
                    minWidth: "60px",
                    minHeight: "60px",
                    margin: "auto",
                    paddingTop: "3px"
                }}>
                <span className={"flag-icon flag-icon-" + transaction.beneficiaryCountryISO2} title={transaction.countryDisplayValue}
                      style={{flex: "1", borderRadius: "30%", minWidth: "45px", minHeight: "45px"}}/>
                </div>
                <div style={{display: "-ms-flexbox", flex: "2", margin: "auto"}}>
                    <div style={{flex: "1", maxWidth: "100%", margin: "auto", fontSize: "10pt"}}>
                        <b>{transaction.fullName}</b>
                    </div>
                    <div style={{flex: "1", margin: "auto", display: "flex"}}>
                        <div style={{justifyContent: "right"}}>
                            <div style={{flex: "1"}}>
                                {transaction.displayDate}
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{width: "100%", margin: "auto", textAlign: "center", fontSize: "10pt", flex: "2"}}>
                    <b style={{marginRight: "10px"}}>R {transaction.amount}</b>
                    {
                        transaction.transactionType === "OUTBOUND"
                        &&
                        <Fragment>
                            <i className={"fa fa-arrow-right"}
                               style={{color: "red"}}/>
                            <b style={{
                                color: "green",
                                marginLeft: "10px"
                            }}>{transaction.currency} {transaction.destinationAmount}</b>
                        </Fragment>
                    }
                </div>

                <div style={{display: "-ms-flexbox", flex:"2", margin: "auto"}}>
                    <div style={{flex: "1", textAlign: "right"}}>
                        {this.renderTransactionType(transaction.transactionType)}
                    </div>
                    <div style={{flex: "1", textAlign: "right"}}>
                        {TransactionStatus.getStatus(transaction.status)}
                    </div>
                </div>

            </div>
        </Fragment>
    }

    renderTransactionType(type) {
        return <Fragment>
            {type === "OUTBOUND" ?
                <Fragment>
                    <i className="fa fa-arrow-right" style={{color: "#124892"}}></i> Sent
                </Fragment>
                :
                <Fragment>
                    <i className="fa fa-arrow-left" style={{color: "#124892"}}></i> Received
                </Fragment>
            }
        </Fragment>
    }

    renderBody(transaction) {
        return <Fragment>
            <div style={{
                textAlign: "center",
                display: "flex",
                padding: "4px 0px"
            }}>
                <div style={{
                    maxWidth: "50%",
                    flex: "1",
                    textAlign: "center",
                    color: "black"
                }}>R {transaction.amount}</div>
                <div style={{
                    maxWidth: "50%",
                    flex: "1",
                    textAlign: "center",
                    color: "green"
                }}>{transaction.currency} {transaction.destinationAmount}</div>
            </div>
        </Fragment>
    }
}
